import React from 'react';
import { Button, List } from '@oscar/theme';
import { ListProps, ListItemProps } from '../FormList/types';
import { FileType } from '.';
import { isNaN, reduce, round } from 'lodash';
import { APIS } from 'common/constants/endpoints';
import { useFormContext } from '@oscar/form';
import apiClient from '@oscar/request';
import { AxiosResponse } from 'axios';
import axios from 'axios';

const MB = 1024 * 1024;

export const ListItem: (props: ListProps<FileType>) => JSX.Element = props => {
  const { title, data, fields, readOnly, formState, removeItem } = props;

  const totalSize = reduce(data, (sum: any, item: any) => sum + item?.size, 0);
  const getSizeFile = (size: any) => (isNaN(size) ? 0 : round(size / MB, 2));

  const downloadFile = async (fileId: string, fileName: string) => {
    try {
      const response = await apiClient.request({
        method: 'GET',
        url: `${APIS.DOWNLOAD_FILE_FROM_AZURE}?fileName=${encodeURIComponent(
          fileName,
        )}`,
        responseType: 'blob',
      });
      const value: any = response;
      const url = window.URL.createObjectURL(value);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName); // Force download
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  return (
    <div className="list">
      <div className="list-title">{title}</div>
      <div className="list-items">
        {data &&
          data.map((value, index) => {
            return (
              <div key={value.fileName} className="file-item">
                <div className="file-item-id">{index + 1}</div>
                <div className="file-item-name">
                  <span
                    onClick={() => downloadFile(value.id, value.fileName)}
                    style={{ cursor: 'pointer', color: '#009089' }}
                  >
                    {value.fileName}
                  </span>
                </div>
                {!readOnly && (
                  <div className="file-item-action">
                    <Button
                      size="small"
                      type="primary"
                      className="remove-button"
                      onClick={() => {
                        if (fields) {
                          removeItem?.(fields?.[index]);
                        }
                      }}
                    >
                      Remove from list
                    </Button>
                  </div>
                )}
              </div>
            );
          })}
      </div>
      {!readOnly && (
        <div className="attachment-footer">{getSizeFile(totalSize)}MB/30MB</div>
      )}
    </div>
  );
};

const Notification: <T = any>(
  props: ListItemProps<T>,
) => JSX.Element = props => {
  const { item, onClickItem, onItemRenderer, field, className = '' } = props;
  return (
    <div
      className={`list-items-item ${className}`}
      onClick={() => onClickItem && onClickItem(item, field)}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          margin: '2px 0',
        }}
      >
        {onItemRenderer(item)}
      </div>
    </div>
  );
};
export default ListItem;
